/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()(() => ({
	content: {
		marginRight: Tokens.spacing['$sp-2'],
	},
	valueContainer: {
		display: 'flex',
		flexDirection: 'row',
		width: `${5 * 8}%`
	},
	pointer: {
		cursor: 'pointer'
	},
	hide: {
		display: 'none'
	},
	newUserValueContainer: {
		fontStyle: 'italic'
	},
}));